// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsMoveToSpamDesktopRequest,
  TChatsMoveToSpamDesktopModel,
  IMappers,
  TChatsMoveToSpamDesktopResponse,
  TChatsMoveToSpamDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createChatsMoveToSpamDesktopModel(
  parameters: TChatsMoveToSpamDesktopRequest,
): TChatsMoveToSpamDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/move-to-spam-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsMoveToSpamDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsMoveToSpamDesktopRequest;
}

export async function fetchChatsMoveToSpamDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsMoveToSpamDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsMoveToSpamDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsMoveToSpamDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsMoveToSpamDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsMoveToSpamDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsMoveToSpamDesktopResponse>;
}
